/**
 * Le navigateur gardera-t-il le cookie de session du serveur d'autorisation ? On le lui demande,
 * plutôt que de le déduire d'un rebond.
 *
 * <strong>Pourquoi un témoin posé en JS dit la vérité sur un cookie `HttpOnly`.</strong> Le cookie de
 * session d'uaa est lié à l'hôte du portail — CloudFront y route `/auth_manager/sessions` et
 * `/oauth2/*` —, en `Secure; SameSite=Lax`. Un témoin posé ici, sur le même hôte et avec les mêmes
 * attributs, relève du même réglage : bloquer les cookies d'un site, dans Chrome, Safari ou Firefox,
 * bloque l'écriture par `document.cookie` comme par `Set-Cookie`.
 *
 * <strong>Pourquoi ne plus détecter le rebond.</strong> Sans ce cookie, la remise à l'espace revient
 * ici par `/oauth2/authorize`, et c'est ce retour qu'un marqueur en `sessionStorage` cherchait à
 * voir. Mais un retour sur `/login` sans flux en attente ne dit rien de sa cause : la déconnexion
 * OIDC y atterrit aussi, sur une URI enregistrée à l'identique, donc sans rien pouvoir signaler. Un
 * marqueur, même daté, menait donc à l'écran des cookies la personne qui se reconnectait vite après
 * s'être déconnectée. Le témoin ne garde aucun état : il répond pour cette connexion-ci, et il répond
 * avant de partir.
 */
const PROBE_NAME = 'rm-portal-cookie-probe';

export function sessionCookieAccepted(doc: Document = document): boolean {
  const secure = doc.location?.protocol === 'https:' ? '; Secure' : '';
  try {
    doc.cookie = `${PROBE_NAME}=1; path=/; SameSite=Lax${secure}`;
    const accepted = doc.cookie
      .split(';')
      .some((cookie) => cookie.trim().startsWith(`${PROBE_NAME}=`));
    doc.cookie = `${PROBE_NAME}=; path=/; max-age=0; SameSite=Lax${secure}`;
    return accepted;
  } catch {
    return false;
  }
}
